

const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://bodecom.com',
  excelProyectosPorOrganizaciones: process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES || 'https://bodecom.com',
  // Rutas RELATIVAS a DocumentosFAO en el servidor (el backend las resuelve
  // contra su propia carpeta DocumentosFAO). Nunca deben ser rutas absolutas
  // de disco (tipo /var/www/html/... o /Volumes/...): eso solo funciona en la
  // máquina donde se escribió el valor y rompe en cualquier otro entorno.
  baseDirUrl: 'DocumentosPOA/actividad_41/tarea_414/indicador_73/medio_verificacion_68',
  baseDirEstructuracion: process.env.REACT_APP_BASE_ESTRUCTURACION_URL || 'DocumentosPOA/actividad_13',
};
export default config;
